var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitedarabemirates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 511.999C397.385 511.999 512 397.384 512 255.999C512 114.614 397.385 -0.000976562 256 -0.000976562C114.615 -0.000976562 0 114.614 0 255.999C0 397.384 114.615 511.999 256 511.999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.696 345.042L166.957 496.078C194.689 506.369 224.686 511.999 256 511.999C366.07 511.999 459.906 442.527 496.076 345.042H144.696Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.696 166.956L166.957 15.92C194.689 5.62902 224.686 -0.000976562 256 -0.000976562C366.07 -0.000976562 459.906 69.471 496.076 166.956H144.696Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 255.999C0 366.07 69.473 459.905 166.957 496.076V15.9221C69.473 52.0931 0 145.928 0 255.999Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0 -0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedarabemirates);
export default __webpack_public_path__ + "static/media/united arab emirates.c0bf48181a2e10fb6c3fddda7cdddfd6.svg";
export { ForwardRef as ReactComponent };